(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory((function webpackLoadOptionalExternalModule() { try { return require("react-native"); } catch(e) {} }()));
	else if(typeof define === 'function' && define.amd)
		define(["react-native"], factory);
	else if(typeof exports === 'object')
		exports["NpawPluginRN"] = factory((function webpackLoadOptionalExternalModule() { try { return require("react-native"); } catch(e) {} }()));
	else
		root["NpawPluginRN"] = factory(root["react-native"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__1389__) => {
return 